<template>
  <div
    v-if="count > 0"
    class="tw-mb-[24px] tw-min-w-0 tw-w-full tw-max-w-full max-md:tw-relative max-md:tw-left-1/2 max-md:-tw-translate-x-1/2 max-md:tw-w-[100svw] max-md:tw-max-w-[100svw] md:tw-static md:tw-left-auto md:tw-translate-x-0 md:tw-w-full md:tw-max-w-full"
    :class="{ 'md:tw-px-[12px]': addMdHorizontalPadding }"
  >
    <div
      class="tw-flex tw-min-w-0 tw-max-w-full tw-overflow-x-hidden tw-items-center tw-justify-between tw-gap-3 tw-rounded-none tw-bg-[#F4F6F8] tw-py-[18px] tw-transition-colors md:tw-rounded-[16px] md:tw-bg-[#F3F4F6]"
      :class="
        addMdHorizontalPadding
          ? 'md:tw-mx-[20px] md:tw-p-4 tw-px-4 md:tw-px-[20px]'
          : 'tw-px-[25px] md:tw-p-4'
      "
    >
      <div class="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-3">
        <div class="tw-shrink-0">
          <svg
            class="tw-h-[20px] tw-w-[21px]"
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M20.25 18H18V1.5C18 1.10218 17.842 0.720644 17.5607 0.43934C17.2794 0.158035 16.8978 0 16.5 0H4.5C4.10218 0 3.72064 0.158035 3.43934 0.43934C3.15804 0.720644 3 1.10218 3 1.5V18H0.75C0.551088 18 0.360322 18.079 0.21967 18.2197C0.0790176 18.3603 0 18.5511 0 18.75C0 18.9489 0.0790176 19.1397 0.21967 19.2803C0.360322 19.421 0.551088 19.5 0.75 19.5H20.25C20.4489 19.5 20.6397 19.421 20.7803 19.2803C20.921 19.1397 21 18.9489 21 18.75C21 18.5511 20.921 18.3603 20.7803 18.2197C20.6397 18.079 20.4489 18 20.25 18ZM16.5 18H15V1.5H16.5V18ZM4.5 1.5H13.5V18H4.5V1.5ZM12 10.125C12 10.3475 11.934 10.565 11.8104 10.75C11.6868 10.935 11.5111 11.0792 11.3055 11.1644C11.1 11.2495 10.8738 11.2718 10.6555 11.2284C10.4373 11.185 10.2368 11.0778 10.0795 10.9205C9.92217 10.7632 9.81502 10.5627 9.77162 10.3445C9.72821 10.1262 9.75049 10.90005 9.83564 9.69448C9.92078 9.48891 10.065 9.31321 10.25 9.1896C10.435 9.06598 10.6525 9 10.875 9C11.1734 9 11.4595 9.11853 11.6705 9.3295C11.8815 9.54048 12 9.82663 12 10.125Z"
              fill="#3B4143"
            />
          </svg>
        </div>
        <div class="tw-flex tw-min-w-0 tw-flex-col md:tw-hidden">
          <span class="tw-text-[16px] tw-font-bold tw-leading-tight tw-text-[#3B4143]"
            >{{ count }} spare {{ count === 1 ? 'room' : 'rooms' }}</span
          >
          <span class="tw-mt-0.5 tw-text-[13px] tw-font-normal tw-leading-tight tw-text-[#6B7280]">
            also match your search
          </span>
        </div>
        <p class="tw-mb-0 tw-hidden tw-text-[16px] tw-font-bold tw-leading-tight tw-text-[#3B4143] md:tw-block">
          <span>{{ count }} spare {{ count === 1 ? 'room' : 'rooms' }}</span> also match your search
        </p>
      </div>
      <a
        v-if="sanitizedApplyUrl"
        :href="sanitizedApplyUrl"
        class="tw-inline-flex tw-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-full tw-border-0 tw-bg-white tw-px-4 tw-py-2 tw-text-[14px] md:tw-text-[16px] tw-font-bold tw-text-[#3B4143] tw-no-underline tw-text-inherit tw-shadow-[0_0_0_1px_rgb(209_213_219)] tw-transition-shadow hover:tw-shadow-[0_0_0_2px_#00A2E1] focus-visible:tw-shadow-[0_0_0_2px_#00A2E1] focus:tw-outline-none"
      >
        Apply filter
      </a>
      <button
        v-else
        type="button"
        disabled
        class="tw-inline-flex tw-shrink-0 tw-cursor-default tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-full tw-border-0 tw-bg-white tw-px-4 tw-py-2 tw-text-[14px] md:tw-text-[16px] tw-font-bold tw-text-[#3B4143] tw-shadow-[0_0_0_1px_rgb(209_213_219)] tw-opacity-60"
      >
        Apply filter
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpareRoomsNudge',
  props: {
    count: {
      type: Number,
      default: 0,
    },
    applyUrl: {
      type: String,
      default: '',
    },
    /** Extra horizontal padding on md+ (housemate / grouplist layout). Off for legacy map layout. */
    addMdHorizontalPadding: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    /**
     * In-page reloads use ?reload=true; that must never be on a normal navigation URL
     * or the server returns JSON instead of HTML. Spare-room apply should drop bedroom
     * filter (server URL omits it; strip here if present on a stale or hand-built URL).
     * Pagination should reset so results start at page one.
     */
    sanitizedApplyUrl() {
      if (!this.applyUrl || typeof this.applyUrl !== 'string') {
        return '';
      }
      try {
        const u = new URL(this.applyUrl, window.location.href);
        u.searchParams.delete('reload');
        u.searchParams.delete('bedrooms');
        u.searchParams.delete('page');
        return u.pathname + u.search + u.hash;
      } catch {
        return this.applyUrl;
      }
    },
  },
};
</script>
